import React from 'react'
import { ActivityHistoryResourceSourceEnum } from '../activityHistoryTypes'
import IconBadge from '../../../components/common/icon/IconBadge'
import IconMap from '../../../components/common/icon/IconMap'
import IconLayers from '../../../components/common/icon/IconLayers'
import { Flex } from 'front-end/src/components'

interface ActivityHistoryResourceIconProps {
  sourceType?: keyof typeof ActivityHistoryResourceSourceEnum
}

const RESOURCE_SOURCE_ICONS = {
  [ActivityHistoryResourceSourceEnum.CertificationModelAsStudent]: IconBadge,
  [ActivityHistoryResourceSourceEnum.PathwayModelAsStudent]: IconMap,
  [ActivityHistoryResourceSourceEnum.WorkspaceModelAsMember]: IconLayers
}

const ActivityHistoryResourceIcon = ({
  sourceType
}: ActivityHistoryResourceIconProps) => {
  if (!sourceType) return null

  const Icon = RESOURCE_SOURCE_ICONS[sourceType]

  if (Icon)
    return (
      <Flex mr="4px" height="21px" alignItems="center">
        <Icon />
      </Flex>
    )
  return null
}

export default ActivityHistoryResourceIcon
